export enum TrackedEvent {
    UserSignedUp,
    // részben cshtml-ben van track-elve
    // signUpKind = regular, byInvite, fromPublicMap, fromTrelloPowerup
    UserEmailConfirmed,
    // Még visszatérni rá, akkor jó most a userId hozzárendelés, ha belépve nyom még rá a user?
    DomainClaimed,
    // domainVerificationMethod
    // domainId
    // domain
    DomainOwnershipVerified,
    // domainId
    DomainSsoAuthenticationEnabled,
    // isSsoRequired
    // domainId
    DomainPasswordPolicyEnforced,
    // domainId
    DomainSsoOnlyEnabledOrDisabled,
    // domainId, isSsoOnly = true / false
    WorkspaceCreated,
    // subDomain

    SampleStorymapCreated,

    OnboardingVideoStarted,

    StorymapCreated,
    // kind = regular, byCopy, byImportFromExcel;  hasCollaborators, hasCollection
    StorymapArchived,
    // storymapId
    // context: manageStorymaps,boardSettings
    StorymapRestored,
    // storymapId
    StorymapDeleted, //test
    // storymapId
    // context: manageStorymaps,boardSettings
    StorymapTransferred, //test
    // storymapId
    // context: manageStorymaps,boardSettings

    StorymapVisibilityChanged,
    // storymapId
    // sharedBy=storymapAdmin,workspaceAdmin,
    // shareKind = WSVisible, Private, Public
    // withEnabledCommentingForWorkspaceLevelVisibility = true / false

    StorymapSharedWithPrivateLink,
    // storymapId
    // sharedBy=storymapAdmin,workspaceAdmin,
    //isEnabled = true/false
    // isCommentingEnabled = true/false

    StorymapCollaboratorAdded,
    // storymapId
    // sharedBy=storymapAdmin,workspaceAdmin,
    // role = admin, editor, viewer

    StorymapCollaboratorInvited,
    // storymapId
    // sharedBy=storymapAdmin,workspaceAdmin,
    // role = admin, editor, viewer; bulkInvite

    StorymapCollaboratorDeleted, // memberId=...,
    // storymapId
    StorymapCollaboratorRoleChanged,
    // storymapId
    //fromRole, toRole

    StorymapExported,
    // storymapId
    // exportType
    // xlsxFormat
    StorymapViewerCommentingEnabledOrDisabled,
    // storymapId
    // enabled=true/false, enabledFor = viewerCollaborators, privateLinkViewers, allMemberByWorkspaceVisibleAccess
    StorymapIssueTrackerIntegrationEnabledOrDisabled,
    // storymapId
    // enabled=true/false, toolType = ..., impersonationEnabled = false/true    disconnect esemény is ez
    StorymapTeamChatIntegrationEnabledOrDisabled,
    // storymapId
    // enabled=true/false, toolType = ...
    StorymapPresentationStarted,
    // storymapId

    StorymapPresentationFollowed,
    // storymapId

    StorymapMutedOrUnmuted,
    //storymapId, isMuted = true/false

    StorymapFavoritedOrUnfavorited,
    //storymapId, isFavorite = true/false

    StorymapCollectionCreated,
    //source = manageCollections, newStorymap, numberOfStorymaps: {n}

    StorymapSearchCollapseUnrelated,
    //storymapId

    PersonaCreatedOrEdited,
    // storymapId
    // kind=added,updated,deteted, personaId=...
    PersonaAssignedToCard,

    PresonaShowRelatedCards,
    //storymapId

    //UserLoggedIn - szerver oldal, // isSSO, rememberMe
    UserLoggedOut,
    UserAccountDeleted,
    //Workspace member hozzáadása, és egyből meghívás storymapekre

    BoardViewLevelChanged,
    // viewLevel = 2,3
    BoardZoomLevelChanged,
    // zoomLevel = {n}
    BoardAdaptiveZoomEnabledOrDisabled,
    // isEnabled = true/false
    BoardActivityFeedFiltered,
    // filterBy = cardId,
    // excludingOwnActivities
    BoardPindedOrUnpinned,
    // isPinned = true/false
    BoardSwitchedToFullScreen,

    BoardCommentAdded,
    // cardId=, commentedAs = viewer, editor, privateLinkViewer, workspaceVisibleViewer

    CardsCollapsedOrExpanded,
    // kind=  collapseAll, expandAll, ??-> collapseActivity, expandActivity, expandReleaseRelated
    CardsSearchedAndFiltered,
    // kind = textOnly, useFilters
    CardsImportedFromIssueTracker,
    CardsTrashbinEmptied,

    CardCreated,
    // cardId=
    // cardType
    CardCopied,
    // cardId=
    CardDetailsAddedOrEdited,
    // cardId=
    CardEstimationAddedOrUpdated,
    // cardId= , source = cardDetails, TrelloPowerUp
    CardCommentAdded,
    // cardId=, commentedAs = viewer, editor, privateLinkViewer, workspaceVisibleViewer
    CardWatched,
    // cardId=
    CardUnwatched,
    // cardId=
    CardAttachmentAdded,
    // cardId=
    CardAttachmentDeleted,
    // cardId=
    CardAttachmentNameChanged,
    // cardId=
    CardWebLinkAdded,
    // cardId=
    CardWebLinkDeleted,
    // cardId=
    CardColorChanged,
    // cardId=
    CardStatusUpdated,
    // cardId=
    CardPushedToIssueTracker,
    // cardId=
    CardsOfReleasePushedToIssueTracker,
    // releaseId=
    CardMoved,
    // cardId=
    CardUnscheduled,
    // cardId=
    CardDeleted,
    // cardId=
    CardRestoredFromTrashbin,
    // cardId=
    CardPermanentlyDeleted,
    // cardId=

    CardAnnotationCreatedOrEdited,
    // cardId=

    CardAnntationAssignedToCard,
    // cardId=
    // eventSource = cardContextMenu, cardDetailsDialog
    ReleaseCreated,
    // releaseId=
    ReleaseNameChanged,
    // releaseId=
    ReleaseArchived,
    // releaseId=
    ReleaseRestored,
    // releaseId=
    ReleaseGoalAddedOrEdited,
    // releaseId=
    ReleaseReordered,
    // releaseId=
    ReleaseStartDateUpdated,
    // releaseId=
    ReleaseReleaseDateUpdated,
    // releaseId=
    ReleaseStatusUpdated,
    // releaseId=
    ReleaseDeleted,
    // releaseId=
    ReleaseWatchedOrUnwatched,
    // releaseId= , isWatched = true/false

    SubscriptionPlanSelectedForPurchase,
    // subscriptionPlan = {n}, editors = {n}
    SubscriptionPurchased,
    // unitPrice= {n}, amount = {n}, subscriptionPlan = {n} , editors = {n} , withEuVatNumber = true/false
    SubscriptionUpgraded,
    // unitPrice= {n}, amount = {n}, subscriptionPlan = {n} , editors = {n} , withEuVatNumber = true/false
    // beforeUnitPrice= {n}, beforeAmount = {n}, beforeSubscriptionPlan = {n} , beforeEditors = {n} , beforeWithEuVatNumber = true/false
    SubscriptionDowngraded,
    // unitPrice= {n}, amount = {n}, subscriptionPlan = {n} , editors = {n} , withEuVatNumber = true/false
    // beforeUnitPrice= {n}, beforeAmount = {n}, beforeSubscriptionPlan = {n} , beforeEditors = {n} , beforeWithEuVatNumber = true/false

    WorkspaceMemberInvited,
    // role= observer, member, admin, subscriptionAdmin, canCreateStorymap = true/false, canInviteObserver = true/false, canInviteEditor = true/false, isBulkInvitation
    WorkspaceMemberLockedOut, // memberId=...,
    WorkspaceMemberDeleted, // memberId=...,
    WorkspaceMemberRoleChanged,
    // memberId=..., role, enabledSubrole/disabledSubrole = [createStorymap, inviteObserver, inviteEditor]

    WorkspaceJiraIntegrationEnabled, // instanceType = onpremise, cloud

    WorkspaceEmailDomainAccessControlEnabled, //disabled is kell?
    WorkspaceIpControlEnabled, //disabled is kell?

    WorkspaceDeleted,
    SubscriptionSuspended,
    UserOnboardingInfoSubmitted,
    PageViewed,
}
